'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp, _initialiseProps;

var _reactRedux = require('react-redux');

var _components2 = require('components');

var _modal = require('redux/actions/modal');

var _addresses = require('redux/actions/addresses');

var _PaymentStatus = require('helpers/Order/PaymentStatus');

var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);

var _PaymentStatusLabel = require('components/PaymentStatusLabel/PaymentStatusLabel');

var _PaymentStatusLabel2 = _interopRequireDefault(_PaymentStatusLabel);

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _modal_type = require('redux/actions/modal_type');

var _utils = require('helpers/utils');

require('./style.less');

var _windowOrGlobal = require('window-or-global');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderDetailView: {
        displayName: 'OrderDetailView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/OrderDetail/default/OrderDetailView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderDetailView = _wrapComponent('OrderDetailView')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        preload: state.personal_order_detail.preload,
        preloadPay: state.payment.preload
    };
}, { showModal: _modal.showModal, hide: _modal.hide, addAddress: _addresses.addAddress, showSuccessfulModal: _modal_type.showSuccessfulModal }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(OrderDetailView, _Component);

    function OrderDetailView(props, context) {
        (0, _classCallCheck3.default)(this, OrderDetailView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderDetailView.__proto__ || (0, _getPrototypeOf2.default)(OrderDetailView)).call(this, props, context));

        _initialiseProps.call(_this);

        _this._onPay = function () {};

        var AccountsList = props.user.amount[0];
        var discountSum = props.order.sum / 2;
        if (props.order.discount_sum > 0) {
            discountSum = props.order.discount_sum * 1;
        }

        if (AccountsList.amount > 0 && AccountsList.amount < discountSum) {
            discountSum = AccountsList.amount * 1;
        }
        if (AccountsList.amount == 0 || props.order.sum <= 1) {
            discountSum = 0;
        }
        if (props.order.sum - discountSum < 1) {
            discountSum = props.order.sum - 1;
            if (discountSum < 0) discountSum = 0;
        }
        discountSum = Math.floor(discountSum);
        var bonusValue = discountSum;
        if (props.order.ibonus_data !== null) {
            var IBonusData = _windowOrGlobal.JSON.parse(props.order.ibonus_data);
            bonusValue = 0;
            if (IBonusData.discount_sum) {
                bonusValue = IBonusData.discount_sum * 1;
            }
        } else if (props.order.discount_sum > 0) {
            bonusValue = 0;
        }
        _this.state = {
            disabled: true,
            disabledClick: false,
            bonusValue: bonusValue,
            couponId: null,
            couponToken: null,
            customerCouponId: null,
            delivery_address: props.order && props.order.delivery_address ? props.order.delivery_address : '',
            userAddresses: props.user && props.user.addresses ? props.user.addresses : [],
            client_comment: props.order && props.order.client_comment ? props.order.client_comment : '',
            preload: false
        };
        _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.products));
        // Втыкаем хак для получения товаров из возврата
        _this.props.order.forwardProducts = _this.props.order.forwardOrder ? _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.forwardOrder.products)) : [];
        _this.props.order.sumCurrent = _this.props.order.sum;
        var useCoupon = false;
        var couponProduct = null;
        _this.props.order.productsCurrent.forEach(function (item) {
            if (item.is_coupon === true) {
                useCoupon = true;
                couponProduct = item;
            }
        });
        if (useCoupon) {
            var productsCurrent = _this.props.order.products.filter(function (item) {
                return item.id !== couponProduct.id;
            });
            _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(productsCurrent));
            var changeCount = false;
            _this.props.order.productsCurrent.forEach(function (item) {
                if (item.offer.id === couponProduct.offer.id && item.modifier_option_id === couponProduct.modifier_option_id && item.is_coupon !== true && item.isCoupon !== true) {
                    changeCount = true;
                    item.quantity++;
                    _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
                }
            });
            if (!changeCount) {
                couponProduct.price = couponProduct.offer.price;
                couponProduct.base_price = couponProduct.offer.price;
                _this.props.order.productsCurrent.push(couponProduct);
                _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
            }
            _this.props.user.coupons.forEach(function (item) {
                if (item.offer_id === couponProduct.offer_id && item.modifier_option_id === couponProduct.modifier_option_id) {
                    _this.state.couponId = item.id;
                    _this.state.customerCouponId = item.customer_coupon_id;
                }
            });
        }
        return _this;
    }

    // Хак по аналогии с ЛК мерчанта


    (0, _createClass3.default)(OrderDetailView, [{
        key: '_getPriceSaleWithIBonusDiscount',
        value: function _getPriceSaleWithIBonusDiscount(product) {
            var discount_to_product = this._getIbonusDiscountToProduct(product);
            if (discount_to_product <= 0) {
                return Number(product.base_price);
            }
            return Number(product.base_price) - discount_to_product;
        }
    }, {
        key: '_getIbonusDiscountToProduct',
        value: function _getIbonusDiscountToProduct(product) {
            if (this.state.bonusValue) {
                var orderSum = this.props.order.sum;
                var discountPercent = this.state.bonusValue / (orderSum / 100);
                var bonusDiscountToProduct = product.base_price * (discountPercent / 100);
                return bonusDiscountToProduct;
            }
            return 0;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$order = _props.order,
                order = _props$order === undefined ? {} : _props$order,
                onSaveOrder = _props.onSaveOrder,
                urlToExternalPaymentService = _props.urlToExternalPaymentService,
                setting = _props.setting;


            var products = order.products || [];
            var forwardProducts = order.forwardProducts || [];
            /** @type PaymentStatus */
            var paymentStatus = order.paymentStatus != null ? order.paymentStatus.id : null;
            paymentStatus = new _PaymentStatus2.default(paymentStatus);

            if (forwardProducts.length && this.isRevertOrder(paymentStatus)) {
                this.applyRevertProductsToOrderProducts(products, forwardProducts);
            }

            if (order.sum - this.state.bonusValue < 0 || this.state.bonusValue < 0) {
                this.setState({ bonusValue: 0 });
                this.state.bonusValue = 0;
            }
            var sumDiscount = this.props.order.discount_sum * 1;
            if (order.sum > 0) {
                var AccountsList = this.props.user.amount[0];
                var discountSum = order.sum / 2;
                var addAmount = 0;
                if (order.discount_sum > 0) {
                    addAmount = order.discount_sum * 1;
                }
                if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
                    discountSum = AccountsList.amount * 1 + addAmount;
                }
                if (order.sum - discountSum < 1) {
                    discountSum = order.sum - 1;
                    if (discountSum < 0) discountSum = 0;
                }

                discountSum = Math.floor(discountSum);
                if (this.state.bonusValue > discountSum) {
                    this.setState({ bonusValue: discountSum });
                    this.state.bonusValue = discountSum;
                }
                if (this.props.order.ibonus_data !== null) {
                    var IBonusData = _windowOrGlobal.JSON.parse(this.props.order.ibonus_data);
                    if (IBonusData.discount_sum) {
                        sumDiscount = this.props.order.discount_sum * 1 - IBonusData.discount_sum * 1;
                    }
                }
                sumDiscount = 0;
                this.props.order.products.forEach(function (product) {
                    var discountPerPiece = _this2.props.order.orderDiscounts.reduce(function (discountPerPiece, discount) {
                        var isAdd = product.productDiscounts.find(function (productDiscount) {
                            return productDiscount.discount_id === discount.discount_id;
                        });
                        if (!isAdd) {
                            product.productDiscounts.push(discount);
                        }
                        var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
                        var result = discountPerPiece + sum;
                        return +result;
                    }, 0);
                    // Сделаем общий метод пробежки по массиву и пересчитаем общую сумму со всеми скидками сразу
                    if (product.productDiscounts.length) {
                        discountPerPiece = product.productDiscounts.reduce(function (discountPerPiece, discount) {
                            var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
                            var result = discountPerPiece + sum;
                            return +result;
                        }, 0);
                    }
                    product.discountPerPiece = discountPerPiece;
                    sumDiscount += discountPerPiece * product.quantity;
                    product.additionalInfo = product.additional_info ? _windowOrGlobal.JSON.parse(product.additional_info) : null;
                    if (product.additionalInfo && product.additionalInfo.custom_fields) {
                        product.custom_fields = product.additionalInfo.custom_fields;
                    }
                });
            }
            var isOrderWasPaid = this.isOrderWasPaid();

            if (this.props.payments.length === 0) {
                return _react3.default.createElement(
                    _components2.Preloader,
                    { preload: this.props.preload || this.props.preloadPay || this.state.preload },
                    _react3.default.createElement(
                        'section',
                        { id: 'personal-order-detail' },
                        _react3.default.createElement(_components2.OrderItemsDetail, {
                            isOrderWasPaid: isOrderWasPaid,
                            isRevert: this.isRevertOrder(paymentStatus),
                            products: products,
                            sum: order.sum,
                            onPay: this.onPay,
                            editOrder: this.props.editOrder,
                            cancelOrder: this.props.cancelOrder,
                            id: order.id,
                            user: this.props.user,
                            bonusValue: this.state.bonusValue,
                            onChangeBonusValue: this.onChangeBonusValue,
                            couponSelect: this.couponSelect,
                            couponId: this.state.couponId,
                            sumDiscount: sumDiscount,
                            paymentInId: order.payment_in_id,
                            order_number: order.order_number,
                            setting: setting,
                            delivery_address: this.state.delivery_address,
                            userAddresses: this.state.userAddresses,
                            client_comment: this.state.client_comment,
                            onDeliveryAddressChange: this.onDeliveryAddressChange,
                            onDeliveryAddressSave: function onDeliveryAddressSave() {
                                return onSaveOrder({ delivery_address: _this2.state.delivery_address });
                            },
                            onClientCommentChange: this.onClientCommentChange,
                            onAddAddress: this.onAddAddress,
                            token: order.view_token,
                            ibonus_data: order.ibonus_data,
                            order_type_id: order.type_id,
                            childOrders: order.childOrders,
                            showPay: paymentStatus.isPayActionAvaliable(),
                            payStatus: _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status }),
                            hidePayButton: true
                        })
                    )
                );
            }

            var disButton = function disButton() {
                var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                _this2.setState({
                    disabled: !slug || !paymentStatus.isPayActionAvaliable()
                });
            };

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload || this.props.preloadPay || this.state.preload },
                _react3.default.createElement(
                    'section',
                    { id: 'personal-order-detail' },
                    _react3.default.createElement(_components2.OrderItemsDetail, {
                        isOrderWasPaid: isOrderWasPaid,
                        isRevert: this.isRevertOrder(paymentStatus),
                        products: products,
                        sum: order.sum,
                        onPay: this.onPay,
                        editOrder: this.props.editOrder,
                        cancelOrder: this.props.cancelOrder,
                        id: order.id,
                        user: this.props.user,
                        bonusValue: this.state.bonusValue,
                        onChangeBonusValue: this.onChangeBonusValue,
                        couponSelect: this.couponSelect,
                        couponId: this.state.couponId,
                        sumDiscount: sumDiscount,
                        paymentInId: order.payment_in_id,
                        order_number: order.order_number,
                        setting: setting,
                        delivery_address: this.state.delivery_address,
                        userAddresses: this.state.userAddresses,
                        client_comment: this.state.client_comment,
                        onDeliveryAddressChange: this.onDeliveryAddressChange,
                        onDeliveryAddressSave: function onDeliveryAddressSave() {
                            return onSaveOrder({ delivery_address: _this2.state.delivery_address });
                        },
                        onClientCommentChange: this.onClientCommentChange,
                        onAddAddress: this.onAddAddress,
                        token: order.view_token,
                        orderDate: order.time_create,
                        ibonus_data: order.ibonus_data,
                        order_type_id: order.type_id,
                        childOrders: order.childOrders,
                        showPay: paymentStatus.isPayActionAvaliable(),
                        hideAll: paymentStatus.isOutdated || paymentStatus.isCanceled(),
                        payStatus: _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status }),
                        disabled: this.state.disabled,
                        disabledClick: this.state.disabledClick,
                        paymentList: !paymentStatus.isCanceled() ? _react3.default.createElement(_components2.PaymentList, {
                            payments: this.props.payments,
                            disButton: disButton,
                            order: this.props.order,
                            getInstance: function getInstance(PaymentListComponent) {
                                _this2._onPay = PaymentListComponent.onPay;
                            },
                            warning: this.state.disabledClick && this.state.disabled
                        }) : null
                    })
                )
            );
        }
    }]);
    return OrderDetailView;
}(_react2.Component), _class2.propTypes = {
    order: _react2.PropTypes.object.isRequired,
    payments: _react2.PropTypes.array,
    showModal: _react2.PropTypes.func,
    onPay: _react2.PropTypes.func,
    onSaveOrder: _react2.PropTypes.func.isRequired,
    setting: _react2.PropTypes.object.isRequired
}, _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onPay = function () {
        if (_this3.state.disabled) {
            _this3.setState({ disabledClick: true });
        } else {
            if (_this3.props.order.sum < 1) {
                var alertMessage = (0, _utils.replaceCharToArrayIndex)(_this3.props.lang['error.pipo.operationInvalidMinimalSum'], [_this3.props.lang.code]);
                setTimeout(function () {
                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                }, 0);
                return null;
            }
            _LocalStorageProxy2.default.setItem('shared_coupons', '');
            _this3.setState({ preload: true });
            _this3._onPay({
                clientCommentary: _this3.state.client_comment,
                delivery_address: _this3.state.delivery_address,
                discountSum: _this3.state.bonusValue,
                couponId: _this3.state.couponId,
                couponToken: _this3.state.couponToken,
                customerCouponId: _this3.state.customerCouponId,
                preloadCallback: _this3.onPreloadState
            });
        }
    };

    this.onPreloadState = function () {
        _this3.setState({ preload: false });
    };

    this.onChangeBonusValue = function (e) {
        _this3.setState({ bonusValue: e.target.value });
    };

    this.couponSelect = function (coupon) {
        var lang = _this3.props.lang;

        if (coupon.id === _this3.state.couponId) {
            _this3.setState({ couponId: null });
            _this3.setState({ couponToken: null });
            _this3.setState({ customerCouponId: null });
            _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
            _this3.props.order.sum = _this3.props.order.sumCurrent;
        } else {
            var useCoupon = false;
            _this3.props.order.products.forEach(function (item) {
                if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id && item.isCoupon !== true) {
                    useCoupon = true;
                }
            });
            if (!useCoupon) {
                var modalContent = _react3.default.createElement(
                    'div',
                    { className: 'row no-margin' },
                    _react3.default.createElement(
                        'div',
                        {
                            className: 'col-xs-12' },
                        lang['store.useCoupon.popup.confirmation.p1'],
                        ' ',
                        coupon.offer.name,
                        ' ',
                        lang['store.useCoupon.popup.confirmation.p2']
                    )
                );

                _this3.props.showModal({
                    title: lang['store.useCoupon.popup.title'],
                    content: modalContent,
                    titleSuccess: lang['store.common.yes'],
                    titleClose: lang['store.common.no'],
                    onSuccess: function onSuccess() {
                        _this3.props.order.sum = _this3.props.order.sumCurrent;
                        _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
                        _this3.props.order.products.push({
                            id: coupon.id,
                            isCoupon: true,
                            quantity: 1, price: 0, base_price: 0,
                            modifier_option_id: coupon.modifier_option_id,
                            modifiedOption: coupon.modifiedOption,
                            offer: coupon.offer
                        });
                        _this3.setState({ couponId: coupon.id });
                        _this3.setState({ couponToken: coupon.token });
                        _this3.setState({ customerCouponId: coupon.customer_coupon_id });
                    },
                    modalType: 'del'
                });
            } else {
                _this3.props.order.sum = _this3.props.order.sumCurrent;
                _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
                _this3.props.order.products.forEach(function (item) {
                    if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id) {
                        if (item.quantity === 1) {
                            _this3.props.order.sum = _this3.props.order.sum - item.base_price;
                            item.price = 0;
                            item.base_price = 0;
                            item.isCoupon = true;
                        } else {
                            item.quantity = item.quantity - 1;
                            _this3.props.order.sum = _this3.props.order.sum - item.base_price;
                            _this3.props.order.products.push({
                                id: coupon.id,
                                isCoupon: true,
                                quantity: 1,
                                price: 0, base_price: 0,
                                modifier_option_id: coupon.modifier_option_id,
                                modifiedOption: coupon.modifiedOption,
                                offer: coupon.offer
                            });
                        }
                        _this3.setState({ couponId: coupon.id });
                        _this3.setState({ couponToken: coupon.token });
                        _this3.setState({ customerCouponId: coupon.customer_coupon_id });
                    }
                });
            }
        }
    };

    this.isOrderWasPaid = function () {
        return _this3.props.order.orderStatus.lang_data === 'order.order_status.done';
    };

    this.isRevertOrder = function (paymentStatus) {
        return paymentStatus.isRevert();
    };

    this.onDeliveryAddressChange = function (e) {
        _this3.setState({ delivery_address: e.target.value });
    };

    this.onClientCommentChange = function (e) {
        _this3.setState({ client_comment: e.target.value });
    };

    this.onAddAddress = function (_ref) {
        var _ref$address = _ref.address,
            address = _ref$address === undefined ? null : _ref$address;

        _this3.props.showSuccessfulModal('Адрес сохранен успешно');
        _this3.props.addAddress(address);
    };

    this.applyRevertProductsToOrderProducts = function (products, forwardProducts) {
        products.forEach(function (product) {
            var refunded = forwardProducts.find(function (refunded) {
                return refunded.id_yml === product.id_yml && refunded.name === product.name && refunded.offer_id === product.offer_id;
            });

            if (refunded) {
                product.refundedProduct = refunded;
                // Рекурсивно апдейтим все дочернии элементы
                if (product.childProducts && refunded.childProducts) {
                    _this3.applyRevertProductsToOrderProducts(product.childProducts, refunded.childProducts);
                }
            }
        });
    };
}, _temp)) || _class));

exports.default = OrderDetailView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/OrderDetail/default/OrderDetailView.jsx
// module id = 1829
// module chunks = 0